var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.46875 6.46875L6.4375 0.75C6.625 0.59375 6.8125 0.5 7 0.5C7.1875 0.5 7.34375 0.5625 7.5 0.6875L13.4688 6.40625C13.7812 6.71875 13.7812 7.1875 13.5 7.46875C13.2188 7.78125 12.75 7.78125 12.4375 7.5L7 2.3125L1.5 7.5625C1.21875 7.84375 0.71875 7.84375 0.4375 7.53125C0.15625 7.21875 0.15625 6.75 0.46875 6.46875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.46eb6f0b792431df66a33807e3c2bb8e.svg";
export { ForwardRef as ReactComponent };